<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="sigil_not_in_toc"><span epub:type="pagebreak" id="pagevii" title="vii"></span></h1>
<h2 class="chapter-title---IVP" id="_idParaDest-1"><a id="_idTextAnchor000"></a>Contents</h2>
<div>
<div epub:type="toc" id="_idContainer000">
<p class="firstleft"><a href="#/Text/05_acknowledgments#_idTextAnchor001"><i>Acknowledgments</i> </a></p>
<p class="firstleft"><a href="#/Text/06_ch1#_idTextAnchor015"><b>1</b> Introducing Postmodernism	</a></p>
<p class="firstleft"><a href="#/Text/07_ch2#_idTextAnchor350"><b>2</b> Criteria for Evaluating Postmodernism	</a></p>
<p class="firstleft"><a href="#/Text/08_ch3#_idTextAnchor504"><b>3</b> The Demise of Enlightenment Modernism	</a></p>
<p class="firstleft"><span href="#/Text/09_ch4#_idTextAnchor728" title="Link target outside of Sample"><b>4</b> The Observer as Situated	</span></p>
<p class="firstleft"><span href="#/Text/10_ch5#_idTextAnchor1059" title="Link target outside of Sample"><b>5</b> Philosophy of Language	</span></p>
<p class="firstleft"><span href="#/Text/11_ch6#_idTextAnchor1434" title="Link target outside of Sample"><b>6</b> Truth and Social Construction	</span></p>
<p class="firstleft"><span href="#/Text/12_ch7#_idTextAnchor1597" title="Link target outside of Sample"><b>7</b> Postmodernism and the Self	</span></p>
<p class="firstleft"><span href="#/Text/13_ch8#_idTextAnchor2009" title="Link target outside of Sample"><b>8</b> Realism and Antirealism, Objectivity and Subjectivity	</span></p>
<p class="firstleft"><span href="#/Text/14_ch9#_idTextAnchor2454" title="Link target outside of Sample"><b>9</b> On Metanarratives and Oppression	</span></p>
<p class="firstleft"><span href="#/Text/15_ch10#_idTextAnchor2695" title="Link target outside of Sample"><b>10</b> Doubts About Metanarratives	</span></p>
<p class="firstleft"><span href="#/Text/16_ch11#_idTextAnchor2903" title="Link target outside of Sample"><b>11</b> Truth, Faith, and Postmodernism	</span></p>
<p class="firstleft"> <span href="#/Text/17_ch12#_idTextAnchor3176" title="Link target outside of Sample"><b>12</b> Postmodernism and the Critique of Enlightenment Rationalism	</span></p>
<p class="firstleft"> <span href="#/Text/18_ch13#_idTextAnchor3509" title="Link target outside of Sample"><b>13</b> The Hope of the Gospel	</span></p>
<p class="firstleft"><span href="#/Text/19_ch14#_idTextAnchor3767" title="Link target outside of Sample"><b>14</b> Where Do We Go from Here?	</span></p>
<p class="firstleft"> <span href="#/Text/20_appendix#_idTextAnchor3794" title="Link target outside of Sample"><i>Appendix: Chart on Modernism and Postmodernism</i></span></p>
<p class="firstleft"> <span href="#/Text/21_notes" title="Link target outside of Sample"><i>Notes</i></span></p>
<p class="firstleft"><span href="#/Text/22_authorindex#_idTextAnchor3800" title="Link target outside of Sample"> <i>Author Index</i> </span></p>
<p class="firstleft"><span href="#/Text/23_subjectindex#_idTextAnchor3801" title="Link target outside of Sample"> <i>Subject Index</i> </span></p>
<p class="firstleft"><span href="#/Text/24_scriptureindex#_idTextAnchor3803" title="Link target outside of Sample"> <i>Scripture Index</i> </span></p>
<p class="firstleft"><span href="#/Text/25_praise#_idTextAnchor3804" title="Link target outside of Sample"> <i>Praise for </i><span class="normal">Understanding Postmodernism</span> </span></p>
<p class="firstleft"><span href="#/Text/26_authors#_idTextAnchor3805" title="Link target outside of Sample"> <i>About the Authors</i> </span></p>
<p class="firstleft"><span href="#/Text/27_moreIVP#_idTextAnchor3806" title="Link target outside of Sample"> <i>More Titles from InterVarsity Press</i> </span></p>
<p class="firstleft"><span href="#/Text/28_copyright" title="Link target outside of Sample"> <i>Copyright</i></span></p>
</div>
</div>
<p class="first"><span epub:type="pagebreak" id="pageviii" title="viii"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_contents.vue?30a50064